import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  align-items: center;
  flex-direction: column;
  text-align: center;

  width: 100%;
  height: 93vh;
  background: #fff;
  /* height: 100vh; */
  span {
    margin-top: 120px;
    display: flex;
    align-items: center;
    flex-direction: column;
    text-align: center;
    div {
      color: #333;
    }
  }
`;
